module.exports = __webpack_public_path__ + "img/donutcharticon.1cdb8f32.png";